import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import api from './api';
import factoring from "@/store/modules/factoring";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    factoring,
  },
  state: {
    menu: null,
    user: null,
    token: null,
    expireTime: null,
    gatewayTransaction: null,
    gatewayTransactionConfirmed: false,
    transactionIsPendingPayment: false,
    business: null,
    lastSimulation: null,
    routes: null,
    ip: null,
    transferencias: null,
    businesSelected: null,
    businessLink: null,
    siiConfigurations: null,
    claveSii: null,
    certificadoSii: null,
    estadoCertificado: null, // "VIGENTE", "POR EXPIRAR", "EXPIRADO"
    openMenuPanel: false,
    token_ip: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setBusiness(state, business) {
      state.business = business;
    },
    setEmpresasCount(state, count) {
      // @ts-ignore
      state.user.empresas_count = count;
    },
    setExpireTime(state, expireTime) {
      state.expireTime = expireTime;
    },
    deleteSimulation(state) {
      state.lastSimulation = null;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.expireTime = null;
      state.lastSimulation = null;
      state.menu = null;
      state.business = null;
      state.businesSelected = null;
      state.businessLink = null;
      state.siiConfigurations = null;
      state.claveSii = null;
      state.certificadoSii = null;
      state.estadoCertificado = null;
      state.transferencias = null;
      state.token_ip = null;
      state.openMenuPanel = false;
      api.logout().catch(() => {});
    },
    clearSession(state) {
      state.user = null;
      state.token = null;
      state.expireTime = null;
      state.lastSimulation = null;
      state.menu = null;
      state.business = null;
      state.businesSelected = null;
      state.businessLink = null;
      state.siiConfigurations = null;
      state.claveSii = null;
      state.certificadoSii = null;
      state.estadoCertificado = null;
      state.transferencias = null;
      state.token_ip = null;
      state.openMenuPanel = false;
    },
    clearBusinessContext(state) {
      state.business = null;
      state.businesSelected = null;
      state.businessLink = null;
      state.siiConfigurations = null;
      state.claveSii = null;
      state.certificadoSii = null;
      state.estadoCertificado = null;
      state.transferencias = null;
    },
    setGatewayTransaction(state, transaction) {
      state.gatewayTransaction = transaction;
      state.gatewayTransactionConfirmed = false;
      state.transactionIsPendingPayment = false;
    },
    setTransactionPendingPayment(state) {
      state.transactionIsPendingPayment = true;
    },
    setTransactionPaymentType(state, id) {
      // @ts-ignore
      state.gatewayTransaction.pago_deta_tipo_id = id;
    },
    setRoutes(state, route) {
      state.routes = route;
    },
    setIp(state, payload) {
      state.ip = payload;
    },
    setTransferencias(state, payload) {
      state.transferencias = payload;
    },
    setMenu(state, payload) {
      state.menu = payload;
    },
    setBusinessSelected(state, payload) {
      state.businesSelected = payload;
    },
    setBusinessLink(state, payload) {
      state.businessLink = payload;
    },
    setsiiConfigurations(state, payload) {
      state.siiConfigurations = payload;
    },
    setclaveSii(state, payload) {
      state.claveSii = payload;
    },
    setcertificadoSii(state, payload) {
      state.certificadoSii = payload;
    },
    setEstadoCertificadoSii(state, payload) {
      state.estadoCertificado = payload;
    },
    setOpenMenuPanel(state, estado) {
      state.openMenuPanel = estado;
    },
    setTokenIP(state, token) {
      state.token_ip = token;
    },
  },
  getters: {
    isAuthenticated: (state): boolean => {
      if (!state.user || !state.token) return false;
      if (state.expireTime) {
        const expire = new Date(state.expireTime as any).getTime();
        if (isNaN(expire) || Date.now() > expire) return false;
      }
      return true;
    },
    canBuyTokens: state => () => {
      // @ts-ignore
      return state.user !== null ? true : false;
    },
    canInvest: state => () => {
      // @ts-ignore
      return state.user.invFormCompleto ? true : false;
    },
  },
  actions: {},
});
